import React from 'react'
import { HeaderEl } from './elements'
import { Button } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { Link, withRouter } from 'react-router-dom'
import { getNextLesson, getPrevLesson } from '../../utils'

const Header = ({
  match: {
    params: { chapterId, courseURL, lessonId, livDemyID },
  },
  history,
  chapters,
}) => {
  const nextLesson = getNextLesson(chapters, chapterId, lessonId) || {}
  const prevLesson = getPrevLesson(chapters, chapterId, lessonId) || {}

  const nextLessonUrl = `/${livDemyID}/course/${courseURL}/chapter/${nextLesson.chapter}/lesson/${nextLesson.lesson}`
  const prevLessonUrl = `/${livDemyID}/course/${courseURL}/chapter/${prevLesson.chapter}/lesson/${prevLesson.lesson}`

  return (
    <HeaderEl>
      <Button
        onClick={() => history.push(`/${livDemyID}/course/${courseURL}`)}
        startIcon={<ArrowBackIosIcon />}
      >
        Back
      </Button>
      <div className='right'>
        <Link to={prevLessonUrl}>
          <ArrowBackIosIcon /> <p>Prev Lesson</p>
        </Link>
        <Link to={nextLessonUrl}>
          <ArrowBackIosIcon /> <p>Next Lesson</p>
        </Link>
      </div>
    </HeaderEl>
  )
}

export default withRouter(Header)
